import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import axios from "axios";

const PanelServicios = () => {
  const [servicios, setServicios] = useState([]);
  const [newServicio, setNewServicio] = useState({ titulo: "", descripcion: "", detalle: "" });
  const [imageFile, setImageFile] = useState(null);
  const [editServicio, setEditServicio] = useState({ id: "", titulo: "", descripcion: "", detalle: "" });
  const [editImageFile, setEditImageFile] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedServicioId, setSelectedServicioId] = useState(null);

  const BACK_URL = process.env.REACT_APP_BACKEND_URL + "servicios";

  useEffect(() => {
    const fetchServicios = async () => {
      try {
        const response = await axios.get(BACK_URL);
        setServicios(response.data);
      } catch (error) {
        console.error("Error al obtener los servicios", error);
      }
    };

    fetchServicios();
  }, []);

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleEditFileChange = (e) => {
    setEditImageFile(e.target.files[0]);
  };

  // Agregar servicio
  const handleAddServicio = async () => {
    try {
      const { titulo, descripcion, detalle } = newServicio;
      if (!titulo || !descripcion || !detalle || !imageFile) {
        setSnackbarMessage("Por favor, completa todos los campos y selecciona una imagen");
        setOpenSnackbar(true);
        return;
      }

      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("descripcion", descripcion);
      formData.append("detalle", detalle);
      formData.append("imagen", imageFile);

      await axios.post(BACK_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSnackbarMessage("Servicio agregado exitosamente");
      setOpenSnackbar(true);

      setNewServicio({ titulo: "", descripcion: "", detalle: "" });
      setImageFile(null);

      const response = await axios.get(BACK_URL);
      setServicios(response.data);
    } catch (error) {
      setSnackbarMessage("Error al agregar el servicio");
      setOpenSnackbar(true);
    }
  };

  // Eliminar servicio
  const handleDeleteServicio = async () => {
    if (!selectedServicioId) {
      setSnackbarMessage("No se ha seleccionado un servicio para eliminar");
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.delete(`${BACK_URL}/${selectedServicioId}`);
      setSnackbarMessage("Servicio eliminado exitosamente");
      setOpenSnackbar(true);

      const response = await axios.get(BACK_URL);
      setServicios(response.data);
    } catch (error) {
      setSnackbarMessage("Error al eliminar el servicio");
      setOpenSnackbar(true);
    }

    setOpenDialog(false);
  };

  // Editar servicio
  const handleEditServicio = async () => {
    try {
      const { id, titulo, descripcion, detalle } = editServicio;
      if (!titulo || !descripcion || !detalle) {
        setSnackbarMessage("Por favor, completa todos los campos");
        setOpenSnackbar(true);
        return;
      }

      const formData = new FormData();
      formData.append("titulo", titulo);
      formData.append("descripcion", descripcion);
      formData.append("detalle", detalle);
      if (editImageFile) {
        formData.append("imagen", editImageFile);
      } else {
        formData.append("rutaImagen", editServicio.rutaImagen);
      }

      await axios.put(`${BACK_URL}/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSnackbarMessage("Servicio actualizado exitosamente");
      setOpenSnackbar(true);

      const response = await axios.get(BACK_URL);
      setServicios(response.data);
      setOpenEditDialog(false);
    } catch (error) {
      setSnackbarMessage("Error al actualizar el servicio");
      setOpenSnackbar(true);
    }
  };

  return (
    <Container className="mt-10 p-6 bg-white rounded-lg shadow-lg w-full my-5">
      <Typography variant="h5" className="mb-6 text-center">
        Panel de Administración de Servicios
      </Typography>

      {/* Formulario agregar servicio */}
      <div className="flex gap-4 mb-4">
        <TextField label="Título" variant="outlined" value={newServicio.titulo} onChange={(e) => setNewServicio({ ...newServicio, titulo: e.target.value })} fullWidth />
        <TextField label="Descripción" variant="outlined" value={newServicio.descripcion} onChange={(e) => setNewServicio({ ...newServicio, descripcion: e.target.value })} fullWidth />
        <TextField label="Detalle" variant="outlined" value={newServicio.detalle} onChange={(e) => setNewServicio({ ...newServicio, detalle: e.target.value })} fullWidth />
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
    <Button 
      variant="contained" 
      component="label" 
      color="primary" 
      style={{ marginRight: "10px", textTransform: "none", textAlign: "center" }}
    >
      Seleccionar Imagen
      <input type="file" hidden onChange={handleFileChange} />
    </Button>
    <TextField 
      variant="outlined" 
      value={imageFile ? imageFile.name : "No seleccionado"} 
      fullWidth 
      disabled 
    />
  </div>
        <Button variant="contained" color="primary" className="w-full" onClick={handleAddServicio}>
          Agregar
        </Button>
      </div>

      {/* Lista de servicios */}
      <List className="bg-gray-100 rounded-lg">
        {servicios.length > 0 ? (
          servicios.map((servicio, index) => (
            <ListItem key={index} className="flex justify-between">
              <img src={`${process.env.REACT_APP_BACKEND_URL.replace("/api/", "")}${servicio.rutaImagen}`} alt={servicio.titulo} className="w-16 h-16 object-cover rounded-md" />
              <Typography className="max-w-full truncate">
                {servicio.titulo}: {servicio.descripcion}
              </Typography>
              <div>
                <IconButton onClick={() => { setEditServicio(servicio); setOpenEditDialog(true); }} color="primary">
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => { setSelectedServicioId(servicio.id); setOpenDialog(true); }} color="secondary">
                  <DeleteIcon />
                </IconButton>
              </div>
            </ListItem>
          ))
        ) : (
          <Typography className="text-center text-gray-500">No hay servicios disponibles.</Typography>
        )}
      </List>

      {/* Dialog de eliminación */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent><Typography>¿Estás seguro de que deseas eliminar este servicio?</Typography></DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">Cancelar</Button>
          <Button onClick={handleDeleteServicio} color="secondary">Eliminar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de edición */}
      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>Editar Servicio</DialogTitle>
        <DialogContent>
          <TextField label="Título" variant="outlined" value={editServicio.titulo} onChange={(e) => setEditServicio({ ...editServicio, titulo: e.target.value })} fullWidth margin="normal" />
          <TextField label="Descripción" variant="outlined" value={editServicio.descripcion} onChange={(e) => setEditServicio({ ...editServicio, descripcion: e.target.value })} fullWidth margin="normal" />
          <TextField label="Detalle" variant="outlined" value={editServicio.detalle} onChange={(e) => setEditServicio({ ...editServicio, detalle: e.target.value })} fullWidth margin="normal" />
          <input type="file" onChange={handleEditFileChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancelar</Button>
          <Button onClick={handleEditServicio} color="secondary">Guardar Cambios</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PanelServicios;
